function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "#447355",
  d: "M163.448 133.048c0 4.544-36.466 8.23-81.448 8.23-44.982 0-81.448-3.685-81.448-8.23s36.466-8.23 81.448-8.23c44.982 0 81.448 3.685 81.448 8.23z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6cb86a",
  d: "M26.251 132.281V45.387h112.654v86.894z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#447355",
  d: "M26.28 74.094V45.375h112.654v28.719z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-89.942 82.5 60)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#dce9d5",
  d: "M67.75 69.675V49.793H96.47v19.882z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fa1145",
  d: "M138.866 45.443l-14.517-.015z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fa1145",
  d: "M78.157 45.383l-14.517-.015z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fa1145",
  d: "M47.803 45.352l-12.835-.012"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fa1145",
  d: "M108.511 45.413l-14.517-.015z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6cb86a",
  d: "M20.407 65.514v-31.91H143.61v31.91z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fdc800",
  d: "M72.179 65.506V31.632h19.883v33.874z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M117.904 19.215c-3.906 3.54-16.365 8.305-24.615 9.537 0 0-6.116-.339-1.819-6.198 3.92-5.344 11.387-11.92 21.039-12.357 6.125-.279 10.187 4.675 5.395 9.018zm-70.489-.07c-4.784-4.351-.711-9.298 5.413-9.007 9.65.458 17.105 7.047 21.015 12.399 4.286 5.867-1.83 6.194-1.83 6.194-8.249-1.249-20.699-6.037-24.598-9.585zM111.845.85c-19.277 4.247-26.832 17.475-29.19 22.964C80.308 18.321 72.78 5.077 53.51.792 37.913-2.678 28.756 7.894 36.4 19.249c4.118 6.116 14.296 13.767 35.793 14.78l-.032 31.468 19.882.02.032-31.424c22.203-.769 32.646-8.549 36.842-14.753C136.586 8 127.45-2.59 111.845.85z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-89.943 82 103.5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M52.979 113.134V93.251h58.175v19.883z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#dce9d5",
  d: "M92.076 34.093c22.202-.769 32.646-8.55 36.842-14.753a17.96 17.96 0 0 0 1.702-3.115c-3.74 1.658-9.911 4.102-17.685 6.125-5.542 2.782-13.69 5.512-19.646 6.401 0 0-3.56-.2-3.335-2.899a94.731 94.731 0 0 1-8.308-.016c-1.733-.08-3.931-.346-6.437-.742.992 3.408-3.197 3.636-3.197 3.636-8.248-1.248-20.697-6.037-24.597-9.585-.063-.057-.118-.114-.178-.172a831.728 831.728 0 0 1-12.71-3.313 17.57 17.57 0 0 0 1.874 3.589c4.118 6.116 14.296 13.766 35.793 14.778v.08l19.882.016z"
})))));

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 142,
    viewBox: "0 0 164 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.bf29b850.svg";
export { ForwardRef as ReactComponent };